import { executeRequest, Request, Response } from '@jfs/network'
import { Config } from 'react-native-config'
import { BillerCategoryMasterId, convertBoolValue, getBillId, getImageUrlPath } from '../util/billPaymentUtil'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'
interface ExtraInfo {
  value: string
  name: string
}
const returnExtraInfo = (extraInfo: Array<ExtraInfo>, id: number) => {
  if (extraInfo) {
    return extraInfo
      .filter((item) => item.value !== 'NA' && item.value !== null && item.value !== '')
      .map((item, index) => {
        return {
          ...item,
          id: `${id}_${index}`,
          __typename: 'ExtraInfo',
        }
      })
  }
  return []
}

const getExtraInfo = (extraInfo: Array<ExtraInfo>, key: string) => {
  if (extraInfo) {
    return extraInfo.find((item) => item.name === key)?.value ?? ''
  }
  return []
}

const responseParser = (response: Response) => {
  const responseData = response?.data?.responseObj
  const operatorList = [] as any
  const billList = [] as any
  responseData?.map((item: any) => {
    if (!operatorList.some((operatorItem: any) => operatorItem.id === item?.billerMasterId)) {
      operatorList.push({
        id: item?.billerMasterId,
        __typename: 'Operator',
        autoPayAllow: convertBoolValue(item?.autoPayAllow),
        // TODO : Change this
        categoryId:
          item?.billerCategoryMasterId === BillerCategoryMasterId.JioPayments
            ? BillerCategoryMasterId.PrepaidMobile
            : item?.billerCategoryMasterId === BillerCategoryMasterId.JioPostpaid
              ? BillerCategoryMasterId.PostpaidMobile
              : item?.billerCategoryMasterId,
        logoPath: getImageUrlPath(item?.billerLogoPath ?? ''),
        name: item?.billerName,
        shortName: item?.billerShortName,
        type: item?.billerType,
        isBbps: convertBoolValue(item?.isBbpsBiller),
        maxAmount: item?.maxAmount,
        minAmount: item?.minAmount,
        searchTags: null,
        partialPaymentAllow: convertBoolValue(item?.partialPaymentAllow),
        billFetchAllow: convertBoolValue(item?.billFetchAllow),
        isExistingBiller: false,
        fields: [],
        iDEBPP: null,
        circles: [],
        distributor: [],
        amountLov: item?.amountLov ?? null,
        nickNameField: {
          __typename: 'Nickname',
          id: 0,
          nickNameSuggestions: item?.nickNameSuggestions ?? null,
          nickNameValidationPattern: item?.nickNameValidationPattern ?? '',
          nickNameValidationMessage: item?.nickNameValidationMessage ?? '',
        },
      })
    }

    const billId = getBillId(item.billerMasterId, item?.authenticators ?? [])
    billList.push({
      id: `${item.customerBillerAccountId}`,
      __typename: 'Bill',
      amount: getExtraInfo(item?.extraInfo, 'Bill Amount') ?? '',
      operatorId: item.billerMasterId ?? '',
      categoryId: item?.billerCategoryMasterId ?? '',
      amountAfterDueDate: '',
      date: item?.billDate ?? '',
      dueDate: item.billDueDate ?? '',
      billNumber: item?.billNumber ?? '',
      authenticators: item?.authenticators ?? [],
      labelOfAuthenticators: item?.labelOfAuthenticators ?? [],
      status: item?.paymentStatus,
      customerBillDataId: item?.customerBillDataId ?? 0,
      customerBillerAccountId: item.customerBillerAccountId ?? '',
      shortName: item?.shortName ?? '',
      // alertFlag: false,
      alertMessage: '',
      ebppBillerMasterId: item?.epbbBillerMasterId ?? 0,
      proceedPaymentAlertMsg: '',
      physicalBillUrl: item?.getPhysicalBillUrl ?? '',
      // existingBillerFlag: '',
      extraInfos: returnExtraInfo(item?.extraInfo, billId),
      period: item?.billPeriod ?? '',
      siStatus: convertBoolValue(item?.siStatus),
      siMaxLimit: item?.siMaxLimit ?? '',
      payDaysBefore: item?.payDaysBefore,
      customerName: item?.customerName ?? '',
      type: item?.billerType, // TODO: Need to store Biller Type only (PAYEE, INSTAPAY, BILLER etc)
      scheduledDebitDate: item?.scheduledDebitDate ?? '',
      lastPaymentGreaterThanBillCreatedDate: convertBoolValue(item?.lastPaymentGreaterThanBillCreatedDate),
      createdDate: item.createdDate ?? '',
      lastPaidDate: item.lastPaidDate ?? '',
      circleId: item?.circleDetailsId ?? 0,
      circleName: item?.circleDetailsName ?? '',
      billPresentConsent: convertBoolValue(item?.beneficiary?.billPresentConsent),
      billPresentConsentDisplay: convertBoolValue(item?.beneficiary?.billPresentConsentDisplay),
      lastTxnRefNo: item?.lastTxnRefNo ?? '',
    })
  })
  return { operatorList, billList }
}

const returnBody = () => {
  return {
    domain: {
      id: 'PayMyBill',
      name: 'PayMyBill',
      transactionType: 'BUY',
      description: 'This is for the buy case',
    },
    initiatingEntity: {
      entityId: Config.REACT_APP_CHANNEL_ID,
      channelId: Config.REACT_APP_CHANNEL_ID,
    },
  }
}

export const getDueBillList = (tokens, userAccessToken) => {
  const config = sitConfig(tokens)
  //config.baseUrl = Config.REACT_APP_JFS_BASE_URL
  const request: Request<{}> = {
    apiPath: APIEndPoints.getDueBillList,
    method: 'POST',
    body: returnBody(),
    config: config,
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
    //headers: { ...getHeader() },
  }

  return executeRequest(request).then((response: any) => {
    if (response?.data?.status === 'S') {
      return responseParser(response)
    } else {
      const errorMsg = {
        code: response?.data?.error?.code,
        message: response?.data?.error?.message ?? null,
      }
      throw errorMsg
    }
  })
}
